module.exports = __webpack_public_path__ + "img/emptySearch.5b07a51e.png";